import { useMemo } from "react";
import { useTemplateContext } from "./TemplateContext";

export const useTemplatesMemo = () => {
  const { state, apiTemplates } = useTemplateContext();
  return useMemo(() => {
    var templates = state.isClientType ? apiTemplates?.savedTemplates : apiTemplates?.defaultTemplates;
    if (state.categoryId) {
      return templates?.filter((x) => x.categoryId == state.categoryId) || [];
    }
    return templates || [];
  }, [apiTemplates, state.categoryId, state.isClientType]);
};
